import { Button } from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import Profile from "../../../assets/image/Taifur.jpg";
import "./search.scss";

import { CgProfile } from "react-icons/cg";
import { MdLogout } from "react-icons/md";

const Search = () => {
  const [searchValue, setSerchValue] = useState("");
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    e.preventDefault();
    setSerchValue(e.target.value);
  };

  const handleOpenMenu = () => {
    setToggle(!toggle);
  };

  const handleLogout = () => {
    setToggle(false);
    localStorage.removeItem("loginInfo");
    navigate("/", { replace: true });
  };

  const handleClose = () => {
    setToggle(false);
  };

  return (
    <div className="search-container">
      <div className="search">
        <input
          className="search-inp common-input"
          value={searchValue}
          type="search"
          name="search"
          onChange={handleChange}
          placeholder="Search Your Data"
        />
        <Button className="search-btn common-btn">Search</Button>
      </div>
      <div className="profile">
        <img
          className="profile-btn"
          src={Profile}
          alt="profile"
          onClick={handleOpenMenu}
        />
        <div className={`sub-menu-wrap ${toggle ? "open-menu" : null}`}>
          <div className="sub-menu">
            <div className="user-info">
              <img src={Profile} alt="profile" />
              <h3>Taifur Islam</h3>
            </div>
            <hr />
            <Link to="users" onClick={handleClose}>
              <CgProfile /> <span>Profile</span>
            </Link>
            <Link to="/" onClick={handleLogout}>
              <MdLogout /> <span>Logout</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
